import { adminApiRequest } from "../../utils/apiUtils";

export const ReviewAPI = {
  getPubReviews: () => {
    return adminApiRequest.get("/pub/review").then((res) => res);
  },
  updateReview: (formData: FormData, id: number) => {
    return adminApiRequest
      .put(`/pub/review/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => res);
  },
};
